import React from 'react'

import { useTranslation } from "react-i18next";

import timetable from '../../images/programtable/GenomeBioExpo_TimeTable_20220729_ko.png';
import timetable_en from '../../images/programtable/GenomeBioExpo_TimeTable_20220729_en.png';

const ProgramOverview = () => {
    const { t } = useTranslation();

  return (
    <div className="sect-01-box-01-seminar">
        <div className="sect-tit">{t("program_whole_overview")}</div>
        <div className="map-cont-box" style={{width:"100%", display:"inline-block"}}>
            <div style={{textAlign:"center"}}>
            {
                t("lang") === "ko"
                    ? <img src={timetable} style={{height:"90vh", display:"inline-block"}}/>
                    : <img src={timetable_en} style={{height:"90vh", display:"inline-block"}}/>
            }
            </div>
        </div>
    </div>
  )
}

export default ProgramOverview